define('plugin/paid-attributes/view/step/AttributeListView',['require','marionette','plugin/paid-attributes/view/step/AttributeItemView','lib/view/UnwrapBehavior'],function (require) {
    
    var Parent = require('marionette').CompositeView;
    var AttributeItemView = require('plugin/paid-attributes/view/step/AttributeItemView');
    var UnwrapBehavior = require('lib/view/UnwrapBehavior');

    /**
     * Products composite view (products container)
     *
     * @class ProductListView
     */
    return Parent.extend({

        template: '#paid_attribute_step_list_view',
        childView: AttributeItemView,
        childViewContainer: '#sb_attribute_list_container',
        
        childViewOptions: function (model, index) {
            var service = this.getOption('bookingModel').get('service');
            return {
                hide_duration: service && service.hide_duration
            };
        },
        
        collectionEvents: {
            sync: 'safeRender'
        },
        
        behaviors: {
            UnwrapBehavior: {
                behaviorClass: UnwrapBehavior
            }
        },
        
        initialize: function () {
            Parent.prototype.initialize.apply(this);
            
            var bookingModel = this.getOption('bookingModel');
            this.listenTo(bookingModel, 'change:service', this.safeRender);
        },
        
        safeRender: function () {
            if (!this.isDestroyed) {
                this.render();
            }
        },

        onDomRefresh: function () {
            // @todo let's think how to remove this
            var errors = this.getOption('bookingModel').validationError || {};
            if (errors.global_form) {
                Backbone.Wreqr.radio.vent.trigger('status_message', 'shown');
            } else if (errors && !_.isEmpty(errors)) {
                Backbone.Wreqr.radio.vent.trigger('field_error', 'shown', {
                    'type': 'client_details'
                });
            }
        }

    });

});
